import { render, staticRenderFns } from "./page-feedback.vue?vue&type=template&id=628b62d9"
import script from "./page-feedback.vue?vue&type=script&lang=js"
export * from "./page-feedback.vue?vue&type=script&lang=js"
import style0 from "./page-feedback.vue?vue&type=style&index=0&id=628b62d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports